import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMyLicenseApi,
  getLicensePlansApi,
  changeLicensePlanApi,
} from '../../api/licenseApi'
import { License, LicensePlan, SubscriptionPlanCatalogItem } from '../../types/license'

export const fetchLicense = createAsyncThunk<
  License,
  void,
  { rejectValue: string }
>('license/fetchMyLicense', async (_, thunkAPI) => {
  try {
    return await getMyLicenseApi()
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to fetch license.')
  }
})

export const fetchLicensePlans = createAsyncThunk<
  SubscriptionPlanCatalogItem[],
  void,
  { rejectValue: string }
>('license/fetchPlans', async (_, thunkAPI) => {
  try {
    return await getLicensePlansApi()
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to fetch subscription plans.')
  }
})

export const changeLicensePlan = createAsyncThunk<
  License,
  LicensePlan,
  { rejectValue: string }
>('license/changePlan', async (planKey, thunkAPI) => {
  try {
    return await changeLicensePlanApi(planKey)
  } catch (error: any) {
    const message =
      error?.response?.data?.message || 'Failed to change the subscription plan.'
    return thunkAPI.rejectWithValue(message)
  }
})
